import React, { useEffect, useState, useContext } from "react";
import { Paper } from "@material-ui/core";

import gear from "../../../../img/gear.svg";
import "./HomepageHeader.css";
import globalContent from "../../../../locales";
import { getSelectedLanguage } from "../../../../util/helperFunctions";
import { Context } from "../../../../context/createContext";

const HomepageHeader = () => {
  const { selectedLanguage } = useContext(Context);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (!localStorage.title) {
      localStorage.setItem("title", "Brian Kaplan");
    } else {
      let temp = localStorage.getItem("title");
      setTitle(temp);
    }
  }, [title]);

  return (
    <Paper className="homepageHeaderContainer">
      <h3 id="homepage-header-title">
        {globalContent.wel[selectedLanguage]}
        {title}
      </h3>
      <img src={gear} />
    </Paper>
  );
};

export default HomepageHeader;
